import { computed, ref, watch, nextTick, toRefs, reactive } from 'vue'
import { IMG_URL_MD5_REGEXP } from '@/views/create/gdt/model/project-const.js'
import { replaceImageGroup } from '@/api/material.model'
import { preLoadImg, getImageSizeByObjectUrl } from '@/common/js/utils'
export const useGroupImageUpload = (proxy, props, emit) => {
  const state = reactive({
    groupImageList: [],
    groupIndex: -1,
    suffix: '',
    imageRect: { width: '', height: '' },
    showGroupImageEditModal: false,
    submitLoading: false
  })

  const groupImageUploaderRef = ref(null)

  async function onShowGroupImageEditModal() {
    const imageList = props.formItem.addr?.split(',') || []
    if (imageList.length > 0) {
      state.groupImageList = [imageList.map((i, index) => ({ id: index, preview_url: i }))]
      state.showGroupImageEditModal = true

      const [firstGroup] = state.groupImageList
      state.suffix = firstGroup[0].preview_url.split('.').pop()
      state.imageRect = await preLoadImg(firstGroup[0].preview_url)
    } else {
      proxy.$message.warning('获取组图失败')
    }
  }

  function onGroupImageReplace({ groupIndex }) {
    state.groupIndex = groupIndex
    groupImageUploaderTrigger()
  }

  function onGroupImageUploadSuccess(res, file, fileList) {
    if (fileList.length > 0) {
      const [firstGroup] = state.groupImageList
      firstGroup.splice(state.groupIndex, 1, { id: file.uid, preview_url: file.response.data.url })
      state.groupImageList = [firstGroup]
    }
  }

  function groupImageUploaderTrigger() {
    const uploadEl = document.querySelector('.group-image-replace-upload .el-upload')
    uploadEl.click()
  }

  function onGroupImageReplaceCancel() {
    state.showGroupImageEditModal = false
    state.groupIndex = -1
    state.suffix = ''
    state.imageRect = { width: '', height: '' }
    state.groupImageList = []
  }
  function onGroupImageReplaceConfirm() {
    const urls = state.groupImageList[0].map(i => i.preview_url.replace('https://ptom-resource-cos.caohua.com/ptom/', ''))
    const md5List = urls.map(url => url.match(IMG_URL_MD5_REGEXP)[0])
    const params = {
      detailId: props.formItem.id,
      fileInfo: {
        name: `aa${Date.now()}.${state.suffix}`,
        groupImageMd5s: md5List.join(','),
        groupImageUrls: urls.join(',')
      }
    }
    state.submitLoading = true

    replaceImageGroup(params).then(data => {
      if (data) {
        proxy.$Message.success('替换成功')
        onGroupImageReplaceCancel()
        setTimeout(() => {
          emit('refresh', props.formItem.id)
        }, 200)
      }
    }).finally(() => {
      state.submitLoading = false
    })
  }

  async function onGroupImageBeforeUpload(file) {
    // 不能超过400kb
    if (file.size > 400 * 1024) {
      proxy.$Message.warning('文件大小不能超过400kb')
      return Promise.reject(new Error(''))
    }
    // 上传的图片尺寸必须与第一组图片的尺寸一致
    const { width, height } = state.imageRect
    const { width: fileWidth, height: fileHeight } = await getImageSizeByObjectUrl(file)
    if (fileWidth !== width || fileHeight !== height) {
      proxy.$Message.warning(`上传的图片尺寸必须尺寸一致，${width}x${height}`)
      return Promise.reject(new Error(''))
    }

    if (!file.name.endsWith(state.suffix)) {
      proxy.$Message.warning(`请上传${state.suffix}格式的文件`)
      return Promise.reject(new Error(''))
    }
    return Promise.resolve()
  }

  return {
    ...toRefs(state),
    groupImageUploaderRef,
    onShowGroupImageEditModal,
    onGroupImageReplace,
    onGroupImageBeforeUpload,
    onGroupImageUploadSuccess,
    onGroupImageReplaceCancel,
    onGroupImageReplaceConfirm
  }
}
